import React from 'react';

const CameraIcon = props => (
  <svg viewBox="0 0 20 16" {...props}>
    <path
      fillRule="evenodd"
      stroke="none"
      d="M375.218,68.182a2.68,2.68,0,0,0-1.885-.721H371l-0.532-1.308a1.821,1.821,0,0,0-.723-0.813A1.959,1.959,0,0,0,368.666,65h-5.332a1.961,1.961,0,0,0-1.079.341,1.815,1.815,0,0,0-.723.813L361,67.461h-2.333a2.68,2.68,0,0,0-1.885.721A2.284,2.284,0,0,0,356,69.923v8.616a2.283,2.283,0,0,0,.781,1.74,2.679,2.679,0,0,0,1.885.721h14.666a2.679,2.679,0,0,0,1.885-.721,2.28,2.28,0,0,0,.781-1.74V69.923A2.28,2.28,0,0,0,375.218,68.182ZM369.3,77.274a4.928,4.928,0,0,1-6.593,0,4.065,4.065,0,0,1,0-6.086,4.928,4.928,0,0,1,6.593,0A4.067,4.067,0,0,1,369.3,77.274ZM366,71.461a3.011,3.011,0,0,0-2.119.813,2.614,2.614,0,0,0,0,3.914,3.171,3.171,0,0,0,4.238,0,2.614,2.614,0,0,0,0-3.914A3.012,3.012,0,0,0,366,71.461Z"
      transform="translate(-356 -65)"
    />
  </svg>
);

export default CameraIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/camera-icon.js